import { fetchWithState, getFetchedJSON } from "~/misc/fetch";
import { ActionError } from "~/misc/dispatch";
import { initUser } from "~/modules/user/actions";
import store from "~/store";
import { getUrlQeury } from "~/misc/formatUrlquery";

const saveAccountAPI = (getState, saveData) =>
  fetchWithState(getState, {
    method: "POST",
    url: "/tl/webCarrierPayment/saveAccount",
    body: saveData,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const saveAccountAction = (getData) => (_, getSate) =>
  saveAccountAPI(getSate, getData);

const billInfoAPI = (getState, orderData) =>
  fetchWithState(getState, {
    method: "POST",
    url: `/tl/webCarrierPayment/vip/order`,
    body: {...orderData,source:'carrier web'},
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const billInfoAction = (getData) => (_, getSate) =>
  billInfoAPI(getSate, getData);

const getPaymentInfoApi = (
  getState,
  { id, bussinessCode, orderId, verifykey }
) =>
  fetchWithState(getState, {
    method: "GET",
    header: {
      ["verify-key"]: verifykey,
    },
    url: `/tl/webCarrierPayment/${id}/vip/order?business_code=${bussinessCode}&order_id=${orderId}`,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const getPaymentInfoAction = (getData) => (_, getSate) =>
  getPaymentInfoApi(getSate, getData);

export const payOrderApi = (
  getState,
  { id, bussinessCode, orderId, token }
) => {
  const query = getUrlQeury()
  return fetchWithState(getState, {
    method: "POST",
    url: `/tl/webCarrierPayment/${id}/${bussinessCode}/order/${orderId}/pay`,
    body: {
      "distinctID": id,//userId
      "eventName": "payment",
      "props": {
        "pay successful": 1,
        "Distinct ID": id,
        source: query.from // payment from where is it.
      },
      jsonParam: {
        account_id: id,
        token,
        business_code: bussinessCode,
        order_id: orderId,
        source: "carrier web", // offcial or carrier web
      }
    }
  })
    .then(getFetchedJSON)
    .then((res) => {
      store.dispatch(initUser());
      return res;
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });
};

export const payOrderAction = (_, getState, getData) =>
  payOrderApi(getState, getData);



// WEBPACK FOOTER //
// ./src/pages/Payment/apis/payment.js